<template>
	<div class="row slim-grid-row mb-3-1 rounded-6 p-3 bg-white" style="box-shadow: #0000000d 0px 5px 30px 0px">
    <div class="col-9 align-self-center" @click="detail" :class="{'cursor-pointer': type == 'pcs'}">
      <p class="mb-0 body-2-2 font-bold text-truncate">{{data.name}}</p>
      <p v-if="type == 'kilo'" class="mb-0 body-2-2 text-16 font-bold text-orange d-inline-block align-middle">{{formatCurrency(data.price)}} <span class="body-2 font-semibold text-14">/kilo</span></p>
      <p v-if="type == 'pcs'" class="mb-0 body-2-2 text-16 font-bold text-orange d-inline-block align-middle"><span class="body-2 font-semibold text-14">{{$t('hotel.concierge.start-form')}} </span>{{formatCurrency(data.price)}}</p>
      <p v-if="type == 'pcs'" class="mb-0 body-2-2 text-12 text-green underline cursor-pointer">{{$t('general.detail')}}</p>
    </div>
    <div class="col-3 align-self-center">
      <button type="button" @click="submitCart" :class="is_cart ? 'button-black' : 'button-secondary'" class="text-12 align-top py-1 px-3">{{is_cart ? 'Cancel Service' : 'Select Service'}}</button>
    </div>
    <popupWarningAddProduct v-if="show_popup" @close="show_popup = false"></popupWarningAddProduct>
    <warning-box 
      v-if="show_popup_diff_serv"  
      @yes="addNewDifferentService"
      @no="close"
      title="Different laundry service"
      body="Pemesanan hanya bisa dilakukan pada satu tipe layanan. Apakah anda yakin ingin berganti tipe layanan?"
      btn_primary="Ya, Ganti!"
      btn_secondary="Batal">  
    </warning-box>
  </div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
	import {formatCurrency} from '@/utils/index.js'
  import WarningBox from '@/components/general/WarningBox'
	export default{
		props:['data','type'],
    components:{
      WarningBox
    },
    data(){
      return{
        show_popup: false,
        show_popup_diff_serv: false
      }
    },
		computed:{
			is_cart(){
        let serv_record = this.getConciergeOrder().custom.findIndex(x=>x.service.id == this.data.id)
        if(serv_record == -1){
          return false
        }else{
          return true
        }
      },
		},
		methods:{
			...mapGetters(['getConciergeOrder']),
      ...mapMutations(['setConciergeOrderCustomLaundry','resetConciergeOrder','setConciergeOrderCustomModule']),
			formatCurrency(value){
        return formatCurrency(value);
      },
			detail(){
				if(this.type == 'pcs'){
					this.$emit('detail',this.data)
				}
			},
			submitCart(){
        if(this.type == 'kilo'){
          if(this.getConciergeOrder().custom.length == 0 || this.getConciergeOrder().custom[0].type == 'kilo'){
            let params = {
              type: this.type,
              service: this.data,
              product: [],
              notes: ''
            }
            this.setConciergeOrderCustomModule("laundry")
            this.setConciergeOrderCustomLaundry(params)
          }else if(this.getConciergeOrder().custom[0].type != 'kilo'){
            this.show_popup_diff_serv = true
          }else{
            console.log("UNKNOW FUNCTION")
          }
        }else{
          this.detail()
        }
      },
      close(){
        this.show_popup_diff_serv = false
      },
      addNewDifferentService(){
        this.resetConciergeOrder()
        this.submitCart()
        this.close()
      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/menuServiceLaundry.vue